<script setup lang="ts">
</script>

<template>
  <div class="flex flex-col items-center text-center">
    <h1 class="mb-2 text-2xl text-gray-600 dark:text-gray-100 sm:mx-12 sm:block md:mx-2">
      {{ $t('web.homepage.tagline2') }}
    </h1>
    <p class="mx-12 mb-6 text-base text-gray-600 dark:text-gray-300 sm:mx-2">
      {{ $t('web.homepage.tagline1') }}
    </p>
  </div>
</template>
